import * as React from 'react';
import { Heading2 } from "../../../../elements";
import { FormattedMessage } from '../ReadReportGuideModal';
export const SummaryComment = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Heading2, null,
            React.createElement(FormattedMessage, { id: 'readreport.guidemodal.summary_comment.title' })),
        React.createElement("section", { className: "ImageWithParagraph" },
            React.createElement("div", { className: "SummaryNoteIcon" }),
            React.createElement("article", null,
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: 'readreport.guidemodal.summary_comment.paragraph1' })),
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: 'readreport.guidemodal.summary_comment.paragraph2' })),
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: 'readreport.guidemodal.summary_comment.paragraph3' }))))));
};
